import React, { useEffect, FC } from "react";
import { Button, Input, Table, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { useWarehouseModel } from "../../warehouseModel";
import { ISCMshelfDetail } from "../../warehouseTypes";
import { ColumnsType } from "antd/es/table";
import { warehouseService, IWarehouseFileds, IWarehouseSearch, IWarehouseDetail, IShelfFileds, IShelfInsert, IShelfSearch, IShelfBatchInsert } from "../../warehouseService";
import { ShelfDrawer } from "./ShelfDrawer";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { importPropsConfig } from "@/utils/importFile";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
//货位
export const ShelfTable: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { shelfPgCfg, shelfDataSource, setSelectedShelfRows, selectedShelfRows, shelfLoadData, setShelfDrawer } = useWarehouseModel();
    // importWarehouseShelf,
    // setIShelfDrawer
    useEffect(() => {
        // console.log(id)
        shelfLoadData(id);
    }, [])
    const importloadData = () => {
        shelfLoadData(id);
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setShelfDrawer(true)}
        >{Locale["Add"]}</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedShelfRows.length !== 1) {
                    message.warning("请选择单挑数据进行编辑");
                    return;
                }
                // setIShelfDrawer("edit");
            }}
        >编辑</Button> */}
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/base/warehouse/shelf/import`, importloadData)}>
            <Button className="mr-5" type="link" shape="round">{Locale["Import"]}</Button>
        </Upload>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
            }}
        >导入</Button> */}
    </>;

    const columns: ColumnsType<IShelfFileds> = [
        {
            // title: '序号',
            title: Locale["SN"],
            // width: 80,
            align: "center",
            render: (t, r, i) => <>{i+1}</>
        },
        {
            // title: '货位编码',
            title: Locale["Shelf Code"],
            dataIndex: 'code',
        },
        {
            // title: '所属仓库',
            title: Locale["Warehouse"],
            dataIndex: 'warehouseName',
        },
        {
            // title: '创建人',
            title: Locale["Founder"],
            align: "center",
            dataIndex: 'createUser',
        },
        {
            // title: '创建时间',
            title: Locale["Founder Time"],
            align: "center",
            dataIndex: 'createTime',
        },
        {
            // title: '备注',
            title: Locale["Note"],
            align: "center",
            dataIndex: 'note',
        }
    ];

    const onRow = (record: IShelfFileds) => {
        if (selectedShelfRows.length > 0 && selectedShelfRows[0].id === record.id) {
            setSelectedShelfRows([]);
        } else {
            setSelectedShelfRows([record]);
        }
        // let findArr = selectedShelfRows.find(item => item.id === record.id);
        // if (findArr) {
        //     let filterArr = selectedShelfRows.filter(item => item.id !== record.id);
        //     setSelectedShelfRows(filterArr);
        // } else {
        //     setSelectedShelfRows(origin => [...origin, record]);
        // }
    };
    return (
        <>
            <YhBox title={Locale["New Shelf"]} rightChildren={action}>
                <Table
                    size="small"
                    rowKey={record => record.id as string}
                    rowSelection={{
                        type: "radio",
                        selectedRowKeys: selectedShelfRows.map(item => item.id as string), //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IShelfFileds[]) => {
                            setSelectedShelfRows(selectedRows);
                        }
                    }}
                    columns={columns}
                    dataSource={shelfDataSource}
                    pagination={{
                        ...shelfPgCfg,
                        position: ["bottomCenter"],
                        showTotal: () => `共${shelfPgCfg.total}条`,
                        onChange: (pageNum, pageSize) => {
                            shelfLoadData(id, { pageNum, pageSize })
                        }
                    }}
                    onRow={record => ({
                        onClick: () => onRow(record)
                    })}
                    scroll={{ x: 'max-content',y:300 }}
                />
            </YhBox>
            <ShelfDrawer />
        </>
    )
}

